export const skills = list =>
  list.map(({ id, name, experienceLevel }) => ({
    experienceLevel,
    id,
    tag: name,
  }));
